import { Auth, Storage } from 'aws-amplify'
// import { Auth } from '@aws-amplify/auth'
// import { Storage } from '@aws-amplify/storage'

import awsExports from '../config/aws-exports'

class StorageService {
  constructor() {
    this.PUBLIC_URL = `https://s3.${awsExports.aws_user_files_s3_bucket_region}.amazonaws.com/${awsExports.aws_user_files_s3_bucket}/public/`
    const creds = Auth.configure(awsExports)
    this.storage = Storage
    this.storage.configure(creds)
  }

  async publicUpload(key, file) {
    return this.storage
      .put(key, file, {
        level: 'public',
        contentType: file.type,
      })
      .then(() => `${this.PUBLIC_URL}${key}`)
  }
}

export default StorageService
